import React, { useState, useEffect } from 'react';

export default function ReactBootstrapModal({ children, ...props }) {
    const [ModalComponent, setModalComponent] = useState(null);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            import('react-bootstrap4-modal').then((mod) => {
                setModalComponent(() => mod.default);
            });
        }
    }, []);
    if (!ModalComponent) return null;
    return <ModalComponent {...props}>{children}</ModalComponent>;
}
